<head-meta [title]="this.title" />
<app-help-button src="/assets/help/users/detail.md" />
<article>
    <div class="card w-full bg-base-100 shadow-xl">
        <div class="card-body">
            <ng-container *ngrxLet="user$ as user; error as e; complete as c">
                @if(user) {
                    <div class="navbar bg-base-100">
                        <div class="flex-none">
                          <a routerLink="/users" routerLinkActive="active" class="btn btn-square btn-ghost text-primary"><fa-icon [icon]="faArrowLeft" class="w-5"></fa-icon></a>
                        </div>
                        <div class="flex-1">
                          <h1 class="h1 ml-4">{{user.display_name}}</h1>
                        </div>
                        <div class="flex-none">
                            @if(this.auth.has('user_set_password') && this.id !== this.auth.getUserId()) {
                                <button (click)="setPassword(user)" class="btn btn-ghost text-warning mr-2">
                                    <fa-icon [icon]="faKey" class="w-5"></fa-icon> Set Password
                                </button>
                            }
                            @if(this.auth.has('user_ban') && !user.is_banned && this.id !== this.auth.getUserId()) {
                                <button (click)="disableUser(user)" class="btn btn-ghost text-error mr-2">
                                    <fa-icon [icon]="faBan" class="w-5"></fa-icon> Disable User
                                </button>
                            }
                            @if(this.auth.has('user_ban') && user.is_banned && this.id !== this.auth.getUserId()) {
                                <button (click)="enableUser(user)" class="btn btn-ghost text-success mr-2">
                                    <fa-icon [icon]="faCircleCheck" class="w-5"></fa-icon> Enable User
                                </button>
                            }
                            @if(this.auth.has('user_update')) {
                                <button [routerLink]="'/users/' + this.id + '/edit'" routerLinkActive="active" class="btn btn-ghost text-primary">
                                    <fa-icon [icon]="faPenToSquare" class="w-5"></fa-icon> Edit
                                </button>
                            }
                        </div>
                    </div>
                    <hr class="hr" />
                    @if(user.is_banned && user.banned_until) {
                        <div class="alert alert-warning">
                            <fa-icon [icon]="faExclamationTriangle"></fa-icon>
                            <span>This user account is disabled</span>
                        </div>
                    }
                    <div class="overflow-hidden bg-white shadow sm:rounded-lg">
                        <div class="border-t border-gray-100">
                            <dl class="divide-y divide-gray-100">
                                @if(user.email) {
                                    <div>
                                        <app-detail-display title="Email" [value]="user.email" />
                                    </div>
                                }
                                <div>
                                    <app-created-updated-display [entity]="user" />
                                </div>
                            </dl>
                        </div>
                    </div>
                }
                <app-loading-error-block [error]="e?.error" [complete]="c" />
            </ng-container>
        </div>
    </div>
</article>

<dialog id="password_modal" class="modal">
    <div class="modal-box">
        <h3 class="text-lg font-bold">Password Set Successfully</h3>
        <p class="py-2 text-sm text-gray-500">This password will not be shown again. Copy it now.</p>
        <div class="bg-base-200 rounded-lg p-4 my-2">
            <code class="text-lg select-all">{{generatedPassword}}</code>
        </div>
        <div class="modal-action">
            <button (click)="copyPassword()" class="btn btn-primary"><fa-icon [icon]="faCopy" class="w-5"></fa-icon> Copy to Clipboard</button>
            <form method="dialog">
                <button class="btn" (click)="generatedPassword = null">Close</button>
            </form>
        </div>
    </div>
    <form method="dialog" class="modal-backdrop">
        <button (click)="generatedPassword = null">close</button>
    </form>
</dialog>